import React from 'react';
import { Box, Typography, LinearProgress, Chip, Divider, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { t } from '../../../utils/textUtils';

const ProjectCard = ({ project, statusColors, getProgressColor }) => {
  return (
    <Box key={project.id}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Box sx={{ 
          width: 40, 
          height: 40, 
          borderRadius: '50%', 
          bgcolor: '#0f172a', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          mr: 1.5
        }}>
          <AccountTreeIcon sx={{ color: 'white', fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {project.name}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
            <LocationOnIcon sx={{ fontSize: 14, mr: 0.5 }} />
            {project.location || t('LOKASI TIDAK DISEBUTKAN')}
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {t('PROGRES')}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {project.progress || 0}% / {project.target || 100}%
          </Typography>
        </Box>
        <LinearProgress 
          variant="determinate" 
          value={project.progress || 0} 
          sx={{ 
            height: 8, 
            borderRadius: 4,
            bgcolor: 'rgba(0,0,0,0.05)',
            '& .MuiLinearProgress-bar': {
              bgcolor: getProgressColor(project.progress, project.target || 100)
            }
          }} 
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {t('STATUS')}
        </Typography>
        <Chip 
          label={project.status ? (project.status === 'in_progress' ? t('BERJALAN') : 
            project.status.charAt(0).toUpperCase() + project.status.slice(1).replace(/_/g, ' ')) : t('BERJALAN')} 
          size="small"
          sx={{ 
            bgcolor: statusColors[project.status] || '#2196F3',
            color: 'white',
            fontWeight: 500
          }}
        />
      </Box>
      
      <Divider sx={{ my: 2 }} />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Button 
          variant="contained"
          size="small" 
          component={Link} 
          to={`/projects/${project.id}`}
          startIcon={<AccountTreeIcon />}
          sx={{ 
            bgcolor: '#0f172a',
            '&:hover': { bgcolor: '#0f2952' }
          }}
        >
          {t('DETAIL')}
        </Button>
        <Button 
          variant="contained"
          size="small" 
          component={Link} 
          to={`/progress/update?projectId=${project.id}`}
          startIcon={<EngineeringIcon />}
          sx={{ 
            bgcolor: '#D4AF37',
            '&:hover': { bgcolor: '#C4A030' }
          }}
        >
          {t('UPDATE PROGRES')}
        </Button>
      </Box>
    </Box>
  );
};

export default ProjectCard;
